import './App.css';
import { Navigate, Route, Routes } from "react-router-dom";
import Layout from "./components/Layout";
import {routes} from "./routes/route";
import LoginPage from "./Pages/LoginPage";
import ProtectedRoute from "./routes/ProtectedRoute";
import JoinTrips from "./Pages/JoinTrips";
import RegisterForm from "./Pages/RegisterForm";
import {UserProvider} from './contexts/UserProvider';
import AuthGate from './components/AuthGate';
import {NotificationsProvider} from './contexts/NotificationsContext';


function App() {
    return (
        <UserProvider>
            <AuthGate>
                <NotificationsProvider>
                    <Routes>
                        <Route path="/login" element={<LoginPage/>}/>
                        <Route path="/register" element={<RegisterForm/>}/>

                        <Route path="/"
                               element={
                                   <ProtectedRoute>
                                       <Layout/>
                                   </ProtectedRoute>
                               }
                        >
                            <Route index element={<JoinTrips/>}/>
                            {routes.map((route, index) => (
                                <Route path={route.path} key={index} element={route.element}/>
                            ))}
                        </Route>

                        {/* Catch-all redirect */}
                        <Route path="*" element={<Navigate to="/" replace/>}/>
                    </Routes>
                </NotificationsProvider>
            </AuthGate>
        </UserProvider>
    );
}

export default App;
